/*
  KEP Cromo 2.0 configurator - "Order via WhatsApp" override
  Replaces the Add to cart action with a WhatsApp message containing the configuration.
  Remove the <script> tag for this file in sections/cromo-configurator.liquid to undo.
  Built by TCO Works
*/
(function () {
  var WA_NUMBER = '31644956381';
  var LABEL = 'Order via WhatsApp';
  var CART_RE = /add\s*to\s*cart/i;

  function isOrderButton(el) {
    if (!el || !el.closest) return null;
    var btn = el.closest('button, a, [role="button"]');
    if (!btn || !btn.closest('.cromo-layout')) return null;
    if (btn.getAttribute('data-wa-order') === '1') return btn;
    if (CART_RE.test(btn.textContent || '')) return btn;
    return null;
  }

  function relabel() {
    var nodes = document.querySelectorAll('.cromo-layout button, .cromo-layout a, .cromo-layout [role="button"]');
    for (var i = 0; i < nodes.length; i++) {
      var b = nodes[i];
      if (b.getAttribute('data-wa-order') === '1' || CART_RE.test(b.textContent || '')) {
        b.setAttribute('data-wa-order', '1');
        if (b.textContent.trim() !== LABEL) b.textContent = LABEL;
      }
    }
  }

  function clean(t) {
    return (t || '').replace(/\s+/g, ' ').replace(/—|–/g, '-').trim();
  }

  function collectRows(root) {
    var rows = [];
    var all = root.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      var kids = el.children;
      if (kids.length < 2 || kids.length > 3) continue;
      var leaf = true;
      for (var k = 0; k < kids.length; k++) {
        if (kids[k].children.length > 0 || /^(BUTTON|A|IMG|SVG)$/i.test(kids[k].tagName)) { leaf = false; break; }
      }
      if (!leaf) continue;
      var parts = [];
      for (var j = 0; j < kids.length; j++) {
        var txt = clean(kids[j].textContent);
        if (txt) parts.push(txt);
      }
      if (parts.length >= 2) rows.push(parts[0] + ': ' + parts.slice(1).join(' - '));
    }
    return rows;
  }

  var LABELS = ['Shell', 'Front Insert', 'Rear Insert', 'Visor', 'Strap', 'Frame', 'Grid', 'Subgrid', 'Button', 'Logo', 'Size', 'Name Tag'];

  function rowsByLabel(root) {
    var leaves = [];
    var all = root.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      if (all[i].children.length === 0) leaves.push(all[i]);
    }
    var rows = [];
    for (var l = 0; l < LABELS.length; l++) {
      var want = LABELS[l].toLowerCase();
      for (var j = 0; j < leaves.length; j++) {
        if (clean(leaves[j].textContent).toLowerCase() !== want) continue;
        var row = leaves[j].parentElement;
        while (row && row !== root && row.children.length < 2) row = row.parentElement;
        if (!row || row === root) continue;
        var parts = [];
        for (var c = 0; c < row.children.length; c++) {
          var cell = row.children[c];
          if (cell.contains(leaves[j])) continue;
          var t = clean(cell.textContent);
          if (t) parts.push(t);
        }
        if (parts.length) {
          var texts = parts.filter(function (p) { return !/€|^included$/i.test(p); });
          var prices = parts.filter(function (p) { return /€/.test(p); });
          var value = texts[0] || parts[0];
          for (var v = 1; v < texts.length; v++) {
            if (/ - | \/ /.test(texts[v]) && texts[v].replace(/[\s-]/g, '') === value.replace(/[\s-]/g, '')) value = texts[v];
            else if (texts[v].replace(/[\s-]/g, '') !== value.replace(/[\s-]/g, '')) value += ', ' + texts[v];
          }
          var extra = prices.join(', ');
          rows.push('• ' + LABELS[l] + ': ' + value + (extra ? ' (' + extra + ')' : ''));
          break;
        }
      }
    }
    return rows;
  }

  // Reuse the configurator's own "Copy share link" button to get a link to this exact configuration.
  function getShareLink() {
    var btns = document.querySelectorAll('.cromo-layout button, .cromo-layout a, .cromo-layout [role="button"]');
    var shareBtn = null;
    for (var i = 0; i < btns.length; i++) {
      if (/share\s*link/i.test(btns[i].textContent || '')) { shareBtn = btns[i]; break; }
    }
    if (!shareBtn) return null;
    var captured = null;
    var clip = navigator.clipboard;
    var origWrite = clip && clip.writeText;
    var onCopy = function () {
      var a = document.activeElement;
      var sel = (a && typeof a.value === 'string' && a.value) || String(window.getSelection ? window.getSelection() : '');
      if (sel) captured = sel;
    };
    try {
      if (clip && origWrite) {
        clip.writeText = function (t) { captured = String(t); return Promise.resolve(); };
      }
      document.addEventListener('copy', onCopy, true);
      shareBtn.click();
    } catch (err) {
      /* ignore */
    } finally {
      if (clip && origWrite) {
        try { delete clip.writeText; } catch (e2) { /* ignore */ }
        if (clip.writeText !== origWrite) clip.writeText = origWrite;
      }
      document.removeEventListener('copy', onCopy, true);
    }
    return captured && /^https?:\/\//i.test(captured.trim()) ? captured.trim() : null;
  }

  function buildMessage() {
    var root = document.getElementById('step-13') || document.querySelector('.cromo-right');
    var rows = root ? rowsByLabel(root) : [];
    if (rows.length < 3 && root) rows = collectRows(root);
    if (!rows.length && root) {
      rows = root.innerText.split('\n').map(clean).filter(function (l) {
        return l && !CART_RE.test(l) && l !== LABEL && !/copy share link/i.test(l);
      });
    }
    var total = document.querySelector('.price-total');
    var totalTxt = total ? clean(total.textContent) : '';
    var hasTotal = rows.some(function (r) { return /^total/i.test(r); });
    var msg = 'Hello About Helmets,\n\nI would like to order this KEP Cromo 2.0:\n\n' +
      rows.join('\n') +
      (!hasTotal && totalTxt ? '\n\nTotal: ' + totalTxt : '') +
      '\n\nConfiguration link (for About Helmets):\n' + (getShareLink() || window.location.href);
    return msg;
  }

  document.addEventListener('click', function (e) {
    var btn = isOrderButton(e.target);
    if (!btn) return;
    if (btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    var url = 'https://wa.me/' + WA_NUMBER + '?text=' + encodeURIComponent(buildMessage());
    var w = window.open(url, '_blank');
    if (!w) window.location.href = url;
  }, true);

  function start() {
    relabel();
    var target = document.querySelector('.cromo-layout');
    if (!target || !window.MutationObserver) return;
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () { pending = false; relabel(); }, 0);
    }).observe(target, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
